
export const DIGITAL = 'DIGITAL'
export const OFFLINE = 'OFFLINE'
export const NONE = 'NONE'